var React = require('react');

function SendIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.19531 8.5625H15.9609L3.53906 3.25L6.19531 8.5625ZM6.19531 10.4375L3.53906 15.7891L15.9609 10.4375H6.19531ZM2.71875 0.867188L20.2188 8.36719C20.6875 8.5625 21 9.03125 21 9.53906C21 10.0078 20.6875 10.4766 20.2188 10.6719L2.71875 18.1719C2.25 18.3672 1.66406 18.25 1.3125 17.8594C0.960938 17.5078 0.882812 16.9219 1.11719 16.4531L4.59375 9.5L1.11719 2.58594C0.882812 2.11719 0.960938 1.53125 1.3125 1.14062C1.66406 0.789062 2.25 0.671875 2.71875 0.867188Z","fill":"white"}));
}

SendIcon.defaultProps = {"width":"21","height":"19","viewBox":"0 0 21 19","fill":"none"};

module.exports = SendIcon;

SendIcon.default = SendIcon;
